<template>
  <Main>
    <v-container>
      <v-card>
        <v-card-text>
          <p class="display-1 text--primary">CRC File Viewer</p>
            <v-row>
              <v-col class="py-0" md="4" sm="12">
                <v-select
                  color="red darken-1"
                  item-value="BRANCH_CODE"
                  item-text="BRANCH_CODE"
                  v-model="BranchCode"
                  :items="BranchList"
                  label="Area"
                  @change="getPositionCode()"
                  dense
                  outlined
                ></v-select>
              </v-col>
              <v-col class="py-0" md="4" sm="12">
                <v-select
                  color="red darken-1"
                  item-value="ROLE_POSITION_CODE"
                  item-text="ROLE_POSITION_CODE"
                  v-model="PositionCode"
                  :items="PositionCodeList"
                  label="Position Code"
                  dense
                  outlined
                ></v-select>
              </v-col>
              <v-col class="py-0" md="4" sm="3">
                <v-select
                  color="red darken-1"
                  item-value="IS_ACRYLIC"
                  item-text="IS_ACRYLIC"
                  v-model="isAcrylic"
                  :items="isAcrylicList"
                  label="Is Acrylic ?"
                  dense
                  outlined
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" md="4" sm="12">
                <v-menu
                  v-model="isShowStartDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      color="red darken-1"
                      class="mt-0 pt-0"
                      v-model="startDate"
                      label="Start Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="startDate"
                    @input="isShowStartDate = false"
                    color="red darken-1"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="py-0" md="4" sm="12">
                <v-menu
                  v-model="isShowEndDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      color="red darken-1"
                      class="mt-0 pt-0"
                      v-model="endDate"
                      label="End Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="endDate"
                    @input="isShowEndDate = false"
                    color="red darken-1"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="text-right py-0" md="4">
                <v-btn
                  class="w-100"
                  style="width: 100%"
                  color="warning"
                  @click="getOverview()"
                  >Find</v-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-2" md="4" style="border: 1px solid grey">
                Summary Foto Display
              </v-col>
              <v-col class="py-2" md="4" style="border: 1px solid grey">
                <b>Acrylic : </b> {{ this.acrylicCounter.VERIFIED }}
              </v-col>
              <v-col class="py-2" md="4" style="border: 1px solid grey">
                <b>Total Relasi : </b> {{ this.totalRelasi }}
              </v-col>
            </v-row>
        </v-card-text>
      </v-card>

      <v-card class="pa-3 mt-3" outlined>
        <v-card-title>
          Attachment CRC Display List
          <v-spacer></v-spacer>
          <v-text-field
            color="red darken-1"
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="dtHeaders"
          :items="dtItems"
          :search="search"
          :loading="dtLoading"
          :item-class="itemRowBGDtTable"
          loading-text="Fetching Data..."
        >
          <template v-slot:item.edit="{ item }">
            <v-icon small class="mr-2" @click="previewItem(item)">mdi-eye</v-icon>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- MODAL -->
    <v-row justify="center">
      <v-dialog
        v-if="isShowPreview"
        v-model="isShowPreview"      
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="warning">
            <v-btn icon dark @click="isShowPreview = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Preview Attachment</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="isShowPreview = false">Close</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-container fluid>
            <PreviewImage :imageList="imageList"></PreviewImage>
          </v-container>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- END MODAL -->
  </Main>
</template>

<style>
.acrylic {
  background-color: rgb(223, 255, 210);
}
</style>

<script>
import Main from "@/Main.vue";
import PreviewImage from "./PreviewImage";
import moment from "moment";
import AWS from 'aws-sdk';
import {S3_CONNECTION} from "../../lib/config";

const s3 = new AWS.S3(S3_CONNECTION);

export default {
  components: {
    Main,
    PreviewImage,
  },
  data() {
    return {
      dtHeaders: [
        {
          text: "Area Code",
          value: "BRANCH_CODE",
        },
        {
          text: "Position Code",
          value: "POSITION_CODE",
        },
        {
          text: "Employee Name",
          value: "SALESREP_EMPLOYEE_NAME",
        },
        {
          text: "Customer Name",
          value: "CUSTOMER_NAME",
        },
        {
          text: "Date CRC",
          value: "DATE_CRC",
        },
        {
          text: "Product Group",
          value: "PRODUCT_GROUP_CODE",
        },
        {
          text: "ACRY",
          value: "IS_ACRYLIC",
        },
        {
          text: "Attachment",
          value: "edit",
          sortable: false,
        },
      ],
      isAcrylicList: ["Y", "N"],
      isAcrylic: "Y",
      dtItems: [],
      search: "",
      dtLoading: false,
      isLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      isShowData: true,
      startDate: moment().startOf("month").format("YYYY-MM-DD"),
      endDate: moment().endOf("month").format("YYYY-MM-DD"),
      isShowStartDate: false,
      isShowEndDate: false,
      BranchList: [],
      BisnisList: [],
      Bisnis: "",
      BranchCode: "ALL",
      PositionCodeList: [],
      PositionCode: "ALL",
      isShowPreview: false,
      imageList: [],
      acrylicCounter: {
        VERIFIED: 0,
        TOTAL: 0,
      },
      totalRelasi: 0,
      imageServer: ''
    };
  },
  created() {
    if (this.$env == "DEV") {
      this.imageServer = "http://localhost:8080";
    } else if (this.$env == "UAT") {
      this.imageServer = "https://imaps.anugrah-argon.com";
    }
  },
  mounted() {
    this.getArea();
    this.dtLoading = false;
    if (this.BranchCode != "") {
      this.getPositionCode();
    }
  },
  methods: {
    itemRowBGDtTable: function (item) {
      return item.IS_ACRYLIC == "Y" ? "acrylic" : "";
    },
    counterAcrylic(IS_ACRYLIC) {
      if (IS_ACRYLIC == "Y") {
        this.acrylicCounter.VERIFIED += 1;
        this.acrylicCounter.TOTAL += 1;
      } else {
        this.acrylicCounter.TOTAL += 1;
      }
    },
    fullSizeImage() {
      console.log("fullSizeImage");
    },
    previewItem(item) {
      this.isLoading = true;
      this.$http.post("/file-viewer/detailOverview", {
        // CRCHeaderID: 33,
        CRCHeaderID: item.CRC_HEADERID,
      }, {
        headers: {
          "api-key": this.$apiKey
        }
      })
      .then(async(res) => {
        const { data } = res.data;
        this.imageList = data;
        for (let i = 0; i < this.imageList.length; i++) {
          if(this.imageList[0].ATTACHMENT_FILE.includes('/api')){
            this.imageList[i].src = this.imageServer + this.imageList[i].ATTACHMENT_FILE;
          }else{
            const params = {
              Bucket: S3_CONNECTION.accessKeyId,
              Key: this.imageList[i].ATTACHMENT_FILE 
            }
            const imageSrc = await s3.getObject(params).promise();
            this.imageList[i].src = `data:image/jpeg;base64,${imageSrc.Body.toString('base64')}`
          }
        }
        this.isLoading = false;
        this.isShowPreview = true;
        this.isPreparingSPV = false;
      })
      .catch((err) => {
        this.isLoading = false;
        this.isPreparingSPV = false;
        this.showSnackbar(err.toString());
      });
    },
    // getBisnis() {
    //     this.dtLoading = true;
    //     this.$http
    //         .get("/file-viewer/selectBisnis")
    //         .then((res) => {
    //             const {
    //                 data
    //             } = res.data;

    //             this.BisnisList = data;
    //             this.isPreparingSPV = false;
    //         })
    //         .catch((err) => {
    //             this.isPreparingSPV = false;
    //             this.showSnackbar(err.toString());
    //         });

    // },
    getArea() {
      this.dtLoading = true;
      const userData = JSON.parse(localStorage.getItem("userData"));
      this.$http
        .post("/file-viewer/selectArea", { username: userData.USER_NAME }, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          const { data } = res.data;
          console.log(res);
          this.BranchList = data;
          this.isPreparingSPV = false;
        })
        .catch((err) => {
          this.isPreparingSPV = false;
          this.showSnackbar(err.toString());
        });
    },
    getPositionCode() {
      // this.dtLoading = true;
      this.$http
        .post("/file-viewer/selectPositionCode", {
          branchCode: this.BranchCode,
        }, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          const { data } = res.data;
          this.PositionCode = "ALL";
          this.PositionCodeList = data;
          this.isPreparingSPV = false;
        })
        .catch((err) => {
          this.isPreparingSPV = false;
          this.showSnackbar(err.toString());
        });
    },
    getOverview() {
      let data = {
        BranchCode: this.BranchCode == "ALL" ? "" : this.BranchCode,
        PositionCode: this.PositionCode == "ALL" ? "" : this.PositionCode,
        Bisnis: this.Bisnis,
        isAcrylic: this.isAcrylic,
        StartDate: this.startDate,
        EndDate: this.endDate,
      };

      console.log(data);

      this.isLoading = true;
      this.dtLoading = true;
      this.$http
        .post("/file-viewer/overview", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          console.log(res.data);
          let { success, message, data } = res.data;
          if (success) {
            this.acrylicCounter.VERIFIED = 0;
            this.acrylicCounter.TOTAL = 0;
            this.isLoading = false;
            this.dtLoading = false;
            this.isShowData = true;
            data = [...new Map(data.map(v => [v.CRC_HEADERID, v])).values()];
            this.totalRelasi = [...new Set(data.map(item => item.CUSTOMER_ID))].length;
            for (let x of data) {
              this.counterAcrylic(x.IS_ACRYLIC);
              x.DATE_CRC = moment(new Date(x.DATE_CRC)).format("DD MMM YYYY HH:MM:ss");
            }

            this.dtItems = data;
            this.showSnackbar("Get Data Success...");
          } else {
            this.isLoading = false;
            this.isShowData = false;
            this.showSnackbar(message);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.isShowData = false;
          this.showSnackbar(err.toString());
        });
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
  },
};
</script>
